<template>
  <p class="u-heading is-marginless">
    <u-breadcrumbs :crumbs="breadcrumbs" />
  </p>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import _ from "@/boot/lodash";
import Context from "@/mixins/context";
import { QUERY_PARAMS } from "@/data/constants";
import type { PropType } from "vue";
import type { ICrumb } from "@/models/breadcrumbs";
import type { IProduct, IProductCategory } from "@/models/products";

export default defineComponent({
  name: "ProductBreadcrumbs",
  mixins: [Context],
  props: {
    product: { type: Object as PropType<IProduct>, required: true }
  },
  computed: {
    breadcrumbs(): ICrumb[] {
      return [
        ...this.$_.map(this.categories, category => ({
          label: category.name,
          route: {
            to: {
              name: this.isAdmin ? "adminOrderShop" : "orderShopStep",
              query: {
                ...this.$_.omitBy(
                  this.$_.omit(this.$router.currentRoute.query, [
                    QUERY_PARAMS.CATEGORY_ID,
                    QUERY_PARAMS.BASKET_PRODUCT_ID,
                    QUERY_PARAMS.PRODUCT_ID,
                    QUERY_PARAMS.CROSS_SELL_PRODUCT,
                    QUERY_PARAMS.BILLING_CYCLE_MONTHS,
                    QUERY_PARAMS.READ_MORE,
                    QUERY_PARAMS.SEARCH,
                    QUERY_PARAMS.SUBPRODUCT_IDS,
                    QUERY_PARAMS.QUANTITY
                  ]),
                  (value, key) =>
                    this.$_.includes(key, QUERY_PARAMS.SUBPRODUCT_QUANTITY)
                ),
                [QUERY_PARAMS.CATEGORY_ID]: `${category.id}`
              }
            }
          }
        })),
        {
          label:
            _.get(this.product, "name_translated") ||
            _.get(this.product, "name")
        }
      ];
    },
    categories() {
      const category = _.get(this.product, "category");
      if (!category) return [];
      return (function getParent(category: IProductCategory) {
        let categories = [
          {
            ..._.pick(category, ["id", "level"]),
            name: category.name_translated || category.name
          }
        ];
        const parent = _.get(category, "top_category");
        if (parent) categories = categories.concat(getParent(parent));
        return categories;
      })(category).reverse() as IProductCategory[];
    }
  }
});
</script>
